export enum LabelType {
  UNDEFINED = "UNDEFINED",
  MANUAL = "MANUAL", // System
  AUTOMATIC = "AUTOMATIC",
  PERSONAL = "PERSONAL"
}

type Color = "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning"

export const LabelColor: { [id: string]: Color } = {
  [LabelType.UNDEFINED]: "default",
  [LabelType.MANUAL]: "default",
  [LabelType.AUTOMATIC]: "success",
  [LabelType.PERSONAL]: "info"
}
